import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { updatePost, togglePublishPost } from "@/api/post";
import { toast } from "sonner";

export const useUpdatePost = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: ({ id, postData }) => updatePost(id, postData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["blogs"] });
      toast.success("Post updated successfully");
      navigate("/dashboard/blogs");
    },
    onError: (error) => {
      console.error("Failed to update post:", error);
      toast.error(error.response?.data?.error || "Failed to update post.");
    },
  });
};
export const useTogglePublishPost = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ postId, isPublished }) => togglePublishPost(postId, isPublished),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ["blogs"], refetchType: "all" });
      toast.success(variables.isPublished ? "Post published" : "Post unpublished");
    },
    onError: () => {
      toast.error("Failed to update status");
    },
  });
};
